module.exports = __webpack_public_path__ + "static/media/facility_recommend_image.723dd746.jpg";